import axios from "axios";

export const getVersionByFunctionalityFromApi = functionality_id =>
  axios.get(`documents/version/last/${functionality_id}`)
    .then(response => response.data)
    .catch(error => error);
